import { t } from 'i18next';
import appVersion from '../../../app-version.json';
import { snackbarService } from '../../components/snackbar/service/snackbar.service';

interface RemoteAppVersion {
  version: string;
  builtAt: string;
  commit: string;
}

const POLL_INTERVAL_MS = 5 * 60 * 1000;
const VERSION_URL = '/app-version.json';

let updateShown = false;
let timerId: ReturnType<typeof setInterval> | null = null;

async function checkAppVersion(): Promise<void> {
  try {
    const response = await fetch(`${VERSION_URL}?t=${String(Date.now())}`, {
      cache: 'no-store',
    });
    if (!response.ok) return;
    const remote = (await response.json()) as RemoteAppVersion;
    if (updateShown || remote.commit === appVersion.commit) return;
    updateShown = true;
    snackbarService.pub.show({
      content: t('common.new_version_available'),
      type: 'info',
      noAutoHide: true,
      showReload: true,
    });
  } catch {
    // Silent fail; next interval will retry.
  }
}

export function startVersionPolling(): void {
  if (import.meta.env.VITE_REACT_APP_ENV !== 'production') return;
  if (timerId !== null) return;
  timerId = setInterval(checkAppVersion, POLL_INTERVAL_MS);
}
